import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import Header from '../../components/header/header';
import ReactPaginate from 'react-paginate';
import { getPayoutListAction } from '../../actions/advisor';
import Currency from '../../components/currency';
import CurrencyFormat from '../../components/currencyFormat/currencyFormat';
import PayAdvisorModal from './PayAdvisorModal';
import { getBusinessAction, resetBusinessList } from '../../actions/businessInfo';
import { SELECT_BOX_THEME, styleSelect } from '../../constants';
import { Controller, useForm, useWatch } from 'react-hook-form';
import Select from "react-select";
import TimeFormat from '../../components/timeFormat/timeFormat';
import debounce from 'lodash/debounce';

export default function Payoutlist() {
    const [page, setPage] = useState(1);
    const [activePage, setActivePage] = useState(0);
    const [status, setStatus] = useState("");
    const [payoutDetail, setPayoutDetail] = useState(null);
    const dispatch = useDispatch();
    const { payoutList, payoutListCount } = useSelector((state) => state.advisor);
    const [open, setOpen] = useState(false);
    const [search, setSearch] = useState("");
    const { businessInfo } = useSelector((state) => state.businessInfo);
    const { control, } = useForm();
    const [searchValue, setSearchValue] = useState('');
    const companyName = useWatch({ control, name: "companyName" });
    useEffect(() => {
        dispatch(getPayoutListAction(page, 20, "", status, companyName ? companyName?._id : ""));
    }, [page, dispatch, activePage, companyName]);

    const handleChange = (inputValue) => {
        setSearchValue(inputValue);
    };

    useEffect(() => {
        const debouncedSearch = debounce((value) => {
            if (value) {
                dispatch(getBusinessAction(1, 100, value, '', '', '', '', '', '', '', '', ''));
            }
            else {
                dispatch(resetBusinessList())
            }
        }, 1000);
        debouncedSearch(searchValue);
        return () => {
            debouncedSearch.cancel();
        };
    }, [searchValue, dispatch]);


    const handlePageClick = (e) => {
        const selectedPage = e.selected;
        setActivePage(selectedPage);
        setPage(selectedPage + 1);
    };

    const handleNavigate = (item) => {
        setOpen(true)
        setPayoutDetail(item)
    }

    const formatOptionLabel = ({ companyName, createdAt, user, isAdvisor }) => {
        console.log("isAdvisor", isAdvisor)
        return (
            <div className="menuController">
                <p className="name">{companyName}</p>
                {isAdvisor &&
                    <p>(advisor)</p>
                }
            </div>
        );
    };
    return (
        <>
            <Header title="Payout manager" />
            <div className="container-fluid py-4">
                <div className="row">
                    <div className="col-lg-12 col-xl-12 col-md-12 col-sm-12 mb-2">
                        <div className="card planList notification h-100">
                            <div className="card-headings">
                                <h6 className="font-weight-bolder payment-text mb-0">
                                    Payout
                                </h6>
                            </div>
                            <div className="searchbar m-0">
                                <Controller
                                    name="companyName"
                                    control={control}
                                    render={({ field }) => (
                                        <Select
                                            className="select-border"
                                            theme={SELECT_BOX_THEME}
                                            {...field}
                                            styles={styleSelect}
                                            isClearable={true}
                                            isSearchable={true}
                                            options={businessInfo}
                                            getOptionLabel={(option) => option?.companyName}
                                            formatOptionLabel={formatOptionLabel}
                                            onInputChange={handleChange}
                                            getOptionValue={(option) => option._id}
                                            placeholder="Search business name"
                                            components={{
                                                DropdownIndicator: () => null,
                                                IndicatorSeparator: () => null,
                                            }}
                                        />
                                    )}
                                />
                                <img src="assets/img/searchIcon.svg" alt="" />

                            </div>
                            <div className="card-body detail">
                                <table className="businessTable userTable">
                                    <thead>
                                        <tr>
                                            <td>Advisor name</td>
                                            <td>Plan name</td>
                                            <td>Type</td>
                                            <td>Price</td>
                                            <td>Advisor share amount</td>
                                            <td>Advisor share amount (USD equivalent)</td>
                                            <td>Balance</td>
                                            <td>Status</td>
                                            <td>Action</td>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {payoutList.length > 0 ? (
                                            payoutList?.map((ele, eleIndex) => (
                                                <tr key={eleIndex}>
                                                    <td>
                                                        <h6 className="profile-text text-sm">
                                                            {ele?.advisor?.first_name || "-"}{" "}
                                                            {ele?.advisor?.last_name && ele?.advisor?.last_name} ({ele?.company?.isAdvisor ? "advisor" : ele?.company?.name})
                                                        </h6>
                                                    </td>
                                                    <td>
                                                        <h6 className="profile-text profile-text-fromuser text-sm">
                                                            {ele?.plan?.name || "-"}{" "}
                                                        </h6>
                                                    </td>
                                                    <td>
                                                        <h6 className="profile-text profile-text-fromuser text-sm">
                                                            {ele?.plan?.type === "kimbocorp" ? "kimbocorp plan" : "Advisor plan" || "-"}{" "}
                                                        </h6>
                                                    </td>
                                                    <td>
                                                        <h6 className="profile-text profile-text-fromuser text-sm">
                                                            <Currency currency={ele?.baseRequestCurrency?.value} />
                                                            <CurrencyFormat currency={ele.baseRequestCurrency?.value} value={ele.planAmount} decimal={2} />
                                                        </h6>
                                                    </td>
                                                    <td>
                                                        <h6 className="profile-text profile-text-fromuser text-sm">
                                                            <Currency currency={ele?.baseRequestCurrency?.value} />
                                                            <CurrencyFormat currency={ele.baseRequestCurrency?.value} value={ele.advisorShareAmountBase} decimal={2} />
                                                        </h6>
                                                    </td>
                                                    <td>
                                                        <h6 className="profile-text profile-text-fromuser text-sm">
                                                            <Currency currency={ele?.currency?.value} />
                                                            <CurrencyFormat currency={ele.currency?.value} value={ele.advisorShareAmount} decimal={2} />
                                                        </h6>
                                                    </td>
                                                    <td>
                                                        <h6 className="profile-text profile-text-fromuser text-sm">
                                                            <Currency currency={ele?.currency?.value} />
                                                            <CurrencyFormat currency={ele.currency?.value} value={ele.pending} decimal={2} />
                                                        </h6>
                                                    </td>
                                                    <td>
                                                        <h6 className="profile-text profile-text-fromuser text-sm text-capitalize">
                                                            {ele?.paymentStatus || "-"}{" "}
                                                        </h6>
                                                    </td>
                                                    <td>
                                                        <div className="">
                                                            {ele?.pending > 0 ?
                                                                <button onClick={() => handleNavigate(ele)} className="btn save-btn editButton">
                                                                    Pay advisor
                                                                </button>
                                                                :
                                                                <button disabled={true} className="btn save-btn editButton">
                                                                    Paid
                                                                </button>
                                                            }

                                                        </div>
                                                    </td>
                                                </tr>
                                            ))
                                        ) : (
                                            <tr className="d-flex pt-3">
                                                <td className="d-flex flex-column justify-content-center">
                                                    <h6 className="mb-0 text-sm table-heading text-center">
                                                        No users found
                                                    </h6>
                                                </td>
                                            </tr>
                                        )}
                                    </tbody>
                                </table>
                            </div>
                            {payoutListCount > 1 && (
                                <div className="pagination-section">
                                    <ReactPaginate
                                        previousLabel={"Prev"}
                                        nextLabel={"Next"}
                                        breakLabel={"..."}
                                        breakClassName={"break-me"}
                                        pageCount={payoutListCount}
                                        marginPagesDisplayed={1}
                                        pageRangeDisplayed={3}
                                        onPageChange={handlePageClick}
                                        containerClassName={"pagination"}
                                        subContainerClassName={"pages pagination"}
                                        activeClassName={"active"}
                                        forcePage={activePage}
                                    />
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>
            <PayAdvisorModal
                isOpen={open}
                onClose={() => setOpen(false)}
                advisor={payoutDetail}
            />
        </>
    )
}
